import { useEffect, useState } from "react";

export const useNetworkInformation = () => {
  const [isOnline, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateNetState = () => {
        // @ts-ignore
        setOnline(navigator.onLine);
      
    };
    addEventListener("load", updateNetState);
    addEventListener("online", updateNetState);
    addEventListener("offline", updateNetState);

    return () => {
        removeEventListener("load", updateNetState);
        removeEventListener("online", updateNetState);
        removeEventListener("offline", updateNetState);
    };
  }, []);

  return isOnline;
};
